import * as angular from "angular";
import * as _ from "lodash"

angular
  .module('bringoz.admin.planning')
  .filter('jobVolume', jobVolume);

/* @ngInject */
function jobVolume(splitService, $filter) {
  return function jobVolumeFilter(job, enableUnitDisplay, defaultValue) {

    const siteUnit = splitService.getVolumeUnit();
    let volume = 0;

    if (_.get(job, 'packages.length')) {
      volume = _.reduce(job.packages, (sum, p) => {
        return sum + _.get(p, 'volume', 0);
      }, 0);
    }

    if (!volume) {
      return defaultValue || '--'
    }
    const volumeUnit = $filter('translate')(siteUnit);
    return (volume).toFixed(Number.isInteger(volume) ? 0 : 2) + (enableUnitDisplay ? (' ' + volumeUnit) : '');
  }
}
